/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/*!
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!   @@@                                         @@@@
 *!   @@@   THIS FILE WAS AUTOGENERATED BY TOOL   @@@@
 *!   @@@   CHANGES MUST TARGET SCRIPTS/SWAGGER   @@@@
 *!   @@@                                         @@@@
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!
 */

import {
  _buildQueryString,
  _emptyParams,
  _encode,
  _getBasePath,
  _getRawBasePath,
} from './urls-utils'

/**
 * GET /api/v1/organizations/{organization_id}/configuration
 * Operation: `get-organization-configuration`
 * Get configuration data associated to an organization.
 * @param {string} params.organizationId Organization id whom you would like to configure access data for.
 * @see 200 The Organization configuration data was retrieved successfully. See {@link OrganizationConfigurationResponse}
 * @see 400 Organization not found. (code: `organization.not_found`). See {@link BasicFailedReply}
 * @return {string} A fully-interpolated and escaped URL
 */
export function getOrganizationConfigurationUrl(
  params: GetOrganizationConfigurationUrlParams,
): string {
  const path = _encode`/organizations/${params.organizationId}/configuration`
  return `${_getRawBasePath()}${path}`
}

export interface GetOrganizationConfigurationUrlParams {
  organizationId: string
}

/**
 * PUT /api/v1/organizations/{organization_id}/configuration
 * Operation: `update-organization-configuration`
 * Updates the organization configuration using PATCH semantics. Only the fields that are referenced in the update are changed.
 * @param {string} params.organizationId Organization id whom you would like to configure access data for.
 * @param {boolean} params.injectDefaultValues Injects default values to the missing fields in the body.
 * @see Accepts a request payload of type {@link OrganizationConfigurationUpdateRequest}
 * @see 200 The organization configuration data was updated successfully. See {@link OrganizationConfigurationResponse}
 * @see 400 Organization not found. (code: `organization.not_found`). See {@link BasicFailedReply}
 * @return {string} A fully-interpolated and escaped URL
 */
export function updateOrganizationConfigurationUrl(
  params: UpdateOrganizationConfigurationUrlParams,
): string {
  const queryString = _buildQueryString({
    injectDefaultValues:
      params.injectDefaultValues === undefined ? false : params.injectDefaultValues,
  })
  const path = _encode`/organizations/${params.organizationId}/configuration`
  return `${_getRawBasePath()}${path}${queryString}`
}

export interface UpdateOrganizationConfigurationUrlParams {
  organizationId: string
  injectDefaultValues?: boolean | null
}

/**
 * PATCH /api/v1/organizations/{organization_id}/configuration
 * Operation: `patch-organization-configuration`
 * Patches the organization configuration. Only the fields that are referenced in the update are changed.
 * @param {string} params.organizationId Organization id whom you would like to configure access data for.
 * @see Accepts a request payload of type {@link OrganizationConfigurationUpdateRequest}
 * @see 200 The organization configuration data was patched successfully. See {@link OrganizationConfigurationResponse}
 * @see 400 Organization not found. (code: `organization.not_found`). See {@link BasicFailedReply}
 * @return {string} A fully-interpolated and escaped URL
 */
export function patchOrganizationConfigurationUrl(
  params: PatchOrganizationConfigurationUrlParams,
): string {
  const path = _encode`/organizations/${params.organizationId}/configuration`
  return `${_getRawBasePath()}${path}`
}

export interface PatchOrganizationConfigurationUrlParams {
  organizationId: string
}
